// extracted by mini-css-extract-plugin
export var animatedSkeletonBlock = "_1i-1";
export var movingGradient = "_1i-4";
export var movingGradientBlock = "_1i-2";
export var skeleton = "_1i-0";
export var skeletonText = "_1i-3";